import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { map, shareReplay, takeUntil } from 'rxjs/operators';

import { LanguageService } from 'src/app/service/language.service';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { StagingMandateStateService } from 'src/app/core/mandates-api/staging-mandate-state.service';
import { UserInfo } from 'src/app/core/authentication/UserInfo';
import { LoadingService } from 'src/app/core/loading/loading.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mandates-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent implements OnInit, OnDestroy {
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map((result) => result.matches),
    shareReplay()
  );

  defaultLang: string = 'nl';
  manualUrl: string = environment.manual.nl;
  faqUrl: string = environment.faq.nl;

  private destroy$ = new Subject<void>();

  constructor(
    private breakpointObserver: BreakpointObserver,
    private languageService: LanguageService,
    private translateService: TranslateService,
    private authService: AuthService,
    private loadingService: LoadingService,
    private stagingMandateStateService: StagingMandateStateService
  ) {}

  async ngOnInit() {
    this.translateService.onDefaultLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ lang }) => {
        this.defaultLang = lang;
        if (lang.includes('fr')) {
          this.manualUrl = environment.manual.fr;
          this.faqUrl = environment.faq.fr;
        } else {
          this.manualUrl = environment.manual.nl;
          this.faqUrl = environment.faq.nl;
        }
      });

    await this.authService.login();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onHelpClick() {
    window.open(this.manualUrl, '_blank');
  }

  onFaqClick() {
    window.open(this.faqUrl, '_blank');
  }

  onSelectionChange(event: any) {
    this.languageService.use(event.value);
  }

  get isAuthenticated$(): Observable<boolean> {
    return this.authService.isAuthenticated$;
  }

  get userInfo$(): Observable<UserInfo | undefined> {
    return this.authService.userInfo$;
  }

  get isLoading$(): Observable<boolean> {
    return this.loadingService.loading$;
  }

  get hasAccessToMandateActions$(): Observable<boolean> {
    return this.stagingMandateStateService.hasAccess$;
  }
}
